export default __webpack_public_path__ + "static/media/carousel7.235fe5ae.png";